import { ProjectFilters } from '@/data/services/projectServices';
import { Fragment } from 'react/jsx-runtime';
import ProjectCarouselFetcher from '../carousel/ProjectCarouselFetcher';
import HackathonBanner from './HackathonBanner/HackathonBanner';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import ProjectCarouselRanking from '../carousel/ProjectCarouselRanking';
import useHackathonFilters from '@/data/hook/hackathon/useHackathonFilters';
import useHackathon from '@/data/hook/hackathon/useHackathon';
import Observable from '@/utils/observers/ObserverPattern';
import { Project } from '@/models/Project';
import { hideParticipants, shouldHideParticipants } from '@/utils/hackathon';
import useAuth from '@/data/hook/useAuth';

type HackathonGeneralProps = {
  filters: ProjectFilters;
};

export default function HackathonGeneral({
  filters: headerFilters,
}: HackathonGeneralProps) {
  const { hackathon, hackathonsStages, isFinish, isLoading } = useHackathon();

  const { user } = useAuth();

  const hackathonFilters = useHackathonFilters();

  const filters = { ...headerFilters, ...hackathonFilters };

  const hideHackathonInformation = (projects: Project[]) =>
    projects.map(hideParticipants);

  const transformProjects = shouldHideParticipants({
    stages: hackathonsStages,
    isLoadingStages: isLoading,
    userType: user?.userType,
  })
    ? hideHackathonInformation
    : undefined;

  const invalidateObserver = new Observable<number, Project>();

  if (!hackathon || !hackathonsStages.length) return <Fragment />;

  return (
    <div className="flex flex-col gap-3.5">
      <ConditionalRenderer condition={!isFinish}>
        <HackathonBanner
          hackathon={hackathon}
          hackathonStages={hackathonsStages}
        />
        <ProjectCarouselFetcher
          section="hackathon"
          filters={filters}
          invalidatesObserver={invalidateObserver}
          route="hackathon"
          transformProjects={transformProjects}
        />
      </ConditionalRenderer>
      <ConditionalRenderer condition={isFinish}>
        <ProjectCarouselRanking
          hackathon={hackathon}
          filters={filters}
          route="hackathon/ranking"
        />
      </ConditionalRenderer>
    </div>
  );
}
